(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var page = document.querySelector(".b2x-page");
    if (!page) return;

    var sticky = page.querySelector(".b2x-sticky");
    var contact = page.querySelector("#b2x-kontakt");
    if (sticky && contact && "IntersectionObserver" in window) {
      var shown = window.matchMedia("(max-width: 767px)").matches;
      if (shown) sticky.classList.add("is-visible");
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (window.matchMedia("(max-width: 767px)").matches) {
            sticky.classList.toggle("is-visible", !entry.isIntersecting);
          } else {
            sticky.classList.remove("is-visible");
          }
        });
      }, { threshold: 0.18 });
      io.observe(contact);
    }

    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    page.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener("click", function (event) {
        var id = link.getAttribute("href");
        if (!id || id === "#") return;
        var target = page.querySelector(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: reduceMotion ? "auto" : "smooth",
          block: "start"
        });
        if (typeof target.focus === "function") {
          target.setAttribute("tabindex", "-1");
          target.focus({ preventScroll: true });
        }
      });
    });
  });
})();
